import * as React from "react";
const Icon = () => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={32} height={32} rx={3} fill="#F3F3F3" />
    <mask
      id="a"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={4}
      y={4}
      width={24}
      height={24}
    >
      <path fill="#D9D9D9" d="M4 4h24v24H4z" />
    </mask>
    <g mask="url(#a)">
      <path
        d="M15 21.75a.73.73 0 0 1-.75-.75.73.73 0 0 1 .75-.75h2q.325 0 .538.212a.73.73 0 0 1 .212.538q0 .325-.212.538a.73.73 0 0 1-.538.212zM8 11.375a.7.7 0 0 1-.537-.225.74.74 0 0 1-.213-.525.726.726 0 0 1 .75-.75h16a.73.73 0 0 1 .75.75q0 .3-.212.525a.7.7 0 0 1-.538.225zm3 5.175a.726.726 0 0 1-.75-.75q0-.3.213-.525A.7.7 0 0 1 11 15.05h10a.7.7 0 0 1 .538.225q.212.225.212.525a.73.73 0 0 1-.75.75z"
        fill="#1A1A1A"
      />
    </g>
  </svg>
);
export default Icon;